/* eslint-disable @next/next/no-img-element */
import { useQuery } from "@apollo/client";
import { GetAsoEbiAttires } from "@src/graphql/queries";
import React from "react";
import styles from "../AsoebiModal/styles.module.scss";
import {
  GetAseobiAttiresQuery,
  GetAseobiAttiresQueryVariables,
} from "@src/@types/api.d";

interface Props {
  asoebi_id: string;
  eventUuid: string | undefined;
}

const AsoebiImages = ({ asoebi_id, eventUuid }: Props) => {
  const { data: asoebiAttires, loading: asoebiAttiresLoading } = useQuery<
    GetAseobiAttiresQuery,
    GetAseobiAttiresQueryVariables
  >(GetAsoEbiAttires, {
    variables: {
      event_id: eventUuid ?? "",
      aseobi_id: asoebi_id,
    },
    fetchPolicy: "cache-and-network",
    // onError(error) {
    //   if (error?.message !== "unauthenticated") {
    //     toast.error(<p>{error?.message ?? "An error occurred"}</p>);
    //   } else {
    //     navigate("/clear");
    //   }
    // },
  });
  const attires = (asoebiAttires?.getAseobiAttires ?? []).filter(
    (item) => item.vendor === "COUPLE"
  );
  return (
    <div
      className={`${styles["custom-scroll"]} flex w-full gap-1 overflow-x-auto`}
    >
      {attires.length !== 0 ? (
        attires.map((attire) => (
          <div key={attire.id} className="w-9 h-9 flex-none">
            {attire.images && (
              <img
                src={attire.images[0]}
                alt=".."
                className="w-full h-full object-cover"
              />
            )}
          </div>
        ))
      ) : (
        <></>
      )}

      {/* <div className="w-9 h-9 bg-red-400"></div>
      <div className="w-9 h-9 bg-red-400"></div> */}
    </div>
  );
};

export default AsoebiImages;
